/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { type ReactNode } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import Heading from '@atlaskit/heading/heading';
import ErrorIcon from '@atlaskit/icon/core/status-error';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	errorContainer: {
		minWidth: '160px',
		paddingBlockStart: token('space.250'),
		paddingInlineEnd: token('space.250'),
		paddingBlockEnd: token('space.250'),
		paddingInlineStart: token('space.250'),
	},
});

export type ErrorFallbackProps = {
	error?: Error;
	errorText: ReactNode;
	title?: ReactNode;
};

export function ErrorContent({ errorText, title }: ErrorFallbackProps): React.JSX.Element {
	return (
		<Flex justifyContent="center" xcss={styles.errorContainer}>
			<Stack space="space.200">
				{title && (
					<Flex gap="space.100" alignItems="center">
						{/* Decorative; the title next to it is the accessible name */}
						<ErrorIcon label="" color={token('color.icon.danger')} />
						<Heading size="small" as="h2">
							{title}
						</Heading>
					</Flex>
				)}
				<Text as="p">{errorText}</Text>
			</Stack>
		</Flex>
	);
}
